export default __webpack_public_path__ + "images/6f5511a061cfd518e1760787ecb3073d.svg";